export enum ApplicationDaysRemainingSeverity {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}
